import classNames from 'classnames';
import * as React from 'react'

interface IReadonlyProps {
    value: string,
    className?: string
}

const Readonly: React.FunctionComponent<IReadonlyProps> = (props) => {
    let { value, className } = props

    return (<div className={classNames("uxp-input-container readonly", className, { "has-content": value?.length > 0 })}
    >
        <div className={classNames("uxp-form-input", { "active": value })} >
            {value}
        </div>
    </div>)
}

export default Readonly